import { type ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import cn from 'classnames'
import { useModal } from 'mmfintech-commons'

import { ModalCloseIcon } from '@icons'

import './modalDialog.scss'

type ModalDialogOptions = {
  closeOnClickOutside?: boolean
  closeOnEscape?: boolean
  hideCloseIcon?: boolean
  scrollable?: boolean
  maxWidth?: number
  onClose?: () => void
}

type ModalDialogProps = {
  content: ReactNode
  options?: ModalDialogOptions
  visible?: boolean
  onClose?: () => void
}

const ModalDialog = ({ content, options, visible, onClose }: ModalDialogProps) => {
  const { ref, width, checkWidth, handleClose, overflowing, modalOptions, handleMouseDown } = useModal({
    options,
    visible,
    onClose
  })

  const location = useLocation()

  useEffect(() => {
    if (visible) {
      onClose?.()
    }
  }, [location.pathname])

  return visible ? (
    <div
      className={cn('modal-dialog-wrapper', { overflowing: overflowing || width < checkWidth })}
      onMouseDown={handleMouseDown}
      ref={ref}
    >
      <div
        className={cn('modal-container', `icon-${modalOptions.closeIconPosition}`, {
          scrollable: modalOptions.scrollable
        })}
      >
        <div className='popup-main-content' onMouseDown={e => e.stopPropagation()}>
          {content}
          {!modalOptions.hideCloseIcon && (
            <div className='popup-close-button-inline' onClick={handleClose}>
              <ModalCloseIcon />
            </div>
          )}
        </div>
        {!modalOptions.hideCloseIcon && (
          <div className='popup-close-button' data-test='popup-close-button' onClick={handleClose}>
            <ModalCloseIcon />
          </div>
        )}
      </div>
    </div>
  ) : null
}

export default ModalDialog
